<template>
    <div class="revenue-filter-box">
        <div class="revenue-filter-box-current" :class="{ disabled: !active }" @click="toggleComboBox">
            <v-switch background-color="success" v-model="active" @click.native.stop></v-switch>
          <span class="selected-items">  REVENUES FILTER </span>
            <span class="revenue-filter-box-open-sign">
                <i v-if="!open" class="fa fa-plus"></i>
                <i v-else class="fa fa-minus"></i>
            </span>
        </div>
        <div class="revenue-filter-box-open" :class="{ open, disabled: !active }">
            <div class="revenue-filter-box-separator"></div>
                <div>
                    <div class="select-box select-box-double" >
                        <div class="select-box-current" v-ripple @click="toggleSelectBox">
                            <span>FROM: {{ this.selectedFromItem ? this.selectedFromItem.text : '' }} </span>
                        </div>
                        <div class="select-box-open" :class="{ open }">
                            <div class="select-box-separator"></div>
                            <div class="select-box-items ">
                                <div class="select-box-item" v-for="item in invertedItems" :key="item.value" @click="selectFromItem(item)" v-ripple>
                                    <i class="fa fa-check" :class="{ visible: selectedFromValue === item.value }"></i>
                                    <span>From: {{ item.text }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="select-box ">
                        <div class="select-box-current" v-ripple @click="toggleSelectBox">
                            <span>TO: {{ this.selectedToItem ? this.selectedToItem.text : '' }} </span>
                        </div>
                        <div class="select-box-open" :class="{ open }">
                            <div class="select-box-separator"></div>
                            <div class="select-box-items">
                                <div class="select-box-item" v-for="item in items" :key="item.value" @click="selectToItem(item)" v-ripple>
                                    <i class="fa fa-check" :class="{ visible: selectedToValue === item.value }"></i>
                                    <span>To: {{ item.text }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>




        </div>
    </div>
</template>

<script>


    export default {
        props: {
            items: {
                type: Array,
                default: () => [],
            },
            value: {
                type: String,
            },
            fromValue: {},
            toValue: {},

            open: {
                type: Boolean,
                default: false,
            },
            reset: {
                type: Boolean,
                default: false
            },
            loader: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                active: true,
                selectedFromValue: null,
                selectedToValue: null,
                invertedItems:[],

            };
        },
        watch: {

            fromValue() {
                this.setDefaultSelectedValue();
            },
            toValue() {
                this.setDefaultSelectedValue();
            },

            value() {
                this.setDefaultSelectedValues();
            },
            filters() {
                this.closeComboBox();
            },
            active() {
                this.onActiveChange();
            },
            reset(){
                this.active = true;
            }
        },
        computed: {
            selectedFromItem() {
                return this.items.find(item => item.value === this.selectedFromValue);
            },
            selectedToItem() {
                return this.items.find(item => item.value === this.selectedToValue);
            },
        },
        created() {
            this.invertedItems =this.items.slice().reverse();
            this.setDefaultSelectedValues();
        },
        methods: {
            toggleComboBox() {
                if (this.active) {
                    this.$emit('update:open', !this.open);
                }
            },
            closeComboBox() {
                this.$emit('update:open', false);
            },
            setDefaultSelectedValues() {


                this.selectedFromValue= this.value ?  this.value.split(',')[0]:this.items[this.items.length - 1].value;
                this.selectedToValue= this.value ?  this.value.split(',')[1]:this.items[0].value;
                this.$emit('input', this.selectedFromValue+','+this.selectedToValue);
            },
            selectFromItem(item) {
                this.selectedFromValue = item.value;
                if(this.selectedFromValue>this.selectedToValue)  this.selectedToValue =this.selectedFromValue ;

                this.$emit('input', this.selectedFromValue+','+this.selectedToValue);
                console.log('input '+ this.selectedFromValue+','+this.selectedToValue);
            },
            selectToItem(item) {
                this.selectedToValue = item.value;
                if(this.selectedFromValue>this.selectedToValue)this.selectedFromValue = this.selectedToValue;
                this.$emit('input', this.selectedFromValue+','+this.selectedToValue);
                console.log('input '+ this.selectedFromValue+','+this.selectedToValue);
            },
            toggleSelectBox() {
                this.open = !this.open;
            },
            onActiveChange() {
                if (!this.active) {
                    this.closeComboBox();
                }

                this.$emit('toggleActive', this.active);
            },
        },
    };

</script>



<style lang="scss">
    @import '../../../style/Charts/Filters/RevenueFilterBox';
</style>
